import router from '@/router'
import axios from '@/axios.js'

const apiUrl = 'https://users.evolugy.com/v1/';

export default {
    registerUser ({dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.post(apiUrl, {payload})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => { reject(error) })
        })
    }
}